import { combineReducers } from "redux";
import {
  CONFIRMATION_ACCEPT,
  CONFIRMATION_DENY,
  CONFIRMATION_REQUEST,
  HELP_TOGGLE,
  HIDE_UPLOADS_TRAY,
  SEARCH_ASSETS,
  SET_PAGE_TITLE,
  SHOW_UPLOADS_TRAY,
  SORT_ASSETS,
  SWITCH_ASSETS_VIEW,
  TOGGLE_FILTER_BAR,
  TOGGLE_UPLOADS_TRAY,
  TOGGLE_UPLOAD_TYPE,
  CHOOSE_UPLOAD,
  START_SINGLE_UPLOAD,
  UPLOAD_BOX_VISIBLE,
  START_UPLOAD,
  REMOVE_START_STATE,
  RESUMABLE_TYPE,
  NORMAL_TYPE,
  SET_AQI_CITIES,
  SET_AQI_STATIONS,
  SET_AIRVEDA_STATIONS,
  TRANSCODE_VIDEO,
  SHOW_GROUP_FEED,
  SET_QUIZ_STATIONS,
  SEARCH_DEVICES,
  UPDATE_PLAYLIST_TAGS_REQUEST,
  UPDATE_PLAYLIST_TAGS_ACCEPT,
  UPDATE_PLAYLIST_TAGS_DENY,

  BULK_PLAYLISTS_UPDATE_REQUEST,
  BULK_PLAYLISTS_UPDATE_ACCEPT,
  BULK_PLAYLISTS_UPDATE_DENY,

  FETCH_PLAYLIST_REQUEST,
  FETCH_PLAYLIST_SUCCESS,
  FETCH_PLAYLIST_FAILURE,

  SET_PLAYLIST,
  UPDATE_PLAYLIST
} from "signoxe/constants/actionTypes";

const uploadTrayOpen = (state = false, action) => {
  switch (action.type) {
    case SHOW_UPLOADS_TRAY:
      return true;
    case HIDE_UPLOADS_TRAY:
      return false;
    case TOGGLE_UPLOADS_TRAY:
      return !state;
    default:
      return state;
  }
};

const uploadTypeSwitch = (state = true, action) => {
  switch (action.type) {
    case TOGGLE_UPLOAD_TYPE:
      return !state;
    case RESUMABLE_TYPE:
      return false;
    case NORMAL_TYPE:
      return true;
    default:
      return state;
  }
};

const uploadDispatchState = (
  state = { choices: [], single: {}, visible: false },
  action
) => {
  switch (action.type) {
    case CHOOSE_UPLOAD:
      return { choice: action.payload, single: {}, visible: true };
    case START_SINGLE_UPLOAD:
      return { choices: [], single: action.payload, visible: true };
    case UPLOAD_BOX_VISIBLE:
      return { ...state, visible: false };
    default:
      return state;
  }
};

const uploadStartState = (state = { start: false, data: {} }, action) => {
  switch (action.type) {
    case START_UPLOAD:
      return { start: true, data: action.payload };
    case REMOVE_START_STATE:
      return { start: false, data: {} };
    default:
      return { start: false, data: {} };
  }
};


const bulkPlaylistsUpdateInitialState = {
  visible: false,
  title: null,
  message: null,
  resourceType: null,
  operation: null,
  id: null,
  playlists: null,
};

const bulkPlaylistsUpdate = (state = bulkPlaylistsUpdateInitialState, action) => {
  switch (action.type) {
    case BULK_PLAYLISTS_UPDATE_REQUEST:
      return {
        visible: true,
        title: action.title,
        message: action.message,
        resourceType: action.resourceType,
        id: action.id,
        operation: action.operation,
        playlists: action.playlists
      };
    case BULK_PLAYLISTS_UPDATE_ACCEPT:
    case BULK_PLAYLISTS_UPDATE_DENY:
      return bulkPlaylistsUpdateInitialState;
    default:
      return state;
  }
};


const playlistUpdateTagsInitialState = {
  visible: false,
  title: null,
  message: null,
  resourceType: null,
  operation: null,
  id: null,
  tags: null,
};

const playlistUpdateTags = (state = playlistUpdateTagsInitialState, action) => {
  switch (action.type) {
    case UPDATE_PLAYLIST_TAGS_REQUEST:
      return {
        visible: true,
        title: action.title,
        message: action.message,
        resourceType: action.resourceType,
        id: action.id,
        operation: action.operation,
        tags: action.tags
      };
    case UPDATE_PLAYLIST_TAGS_ACCEPT:
    case UPDATE_PLAYLIST_TAGS_DENY:
      return playlistUpdateTagsInitialState;
    default:
      return state;
  }
};

const playlistDetailinitialState = {
  data: null,
  loading: false,
  error: null,
};

const playlistDetail = (state = playlistDetailinitialState, action) => {
  switch (action.type) {
    case FETCH_PLAYLIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PLAYLIST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_PLAYLIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // Add other cases for different actions if needed
    default:
      return state;
  }
};


const confirmationInitialState = {
  visible: false,
  title: null,
  message: null,
  resourceType: null,
  operation: null,
  id: null
};

const confirmation = (state = confirmationInitialState, action) => {
  switch (action.type) {
    case CONFIRMATION_REQUEST:
      return {
        visible: true,
        title: action.title,
        message: action.message,
        resourceType: action.resourceType,
        id: action.id,
        operation: action.operation,
      };
    case CONFIRMATION_ACCEPT:
    case CONFIRMATION_DENY:
      return confirmationInitialState;
    default:
      return state;
  }
};

const currentDeviceId = (state = null, action) => {
  if (action.type === SHOW_GROUP_FEED) {
    return action.id;
  } else {
    return state;
  }
};

const searchQuery = (state = "", action) => {
  if (action.type === SEARCH_ASSETS) {
    return action.query;
  } else {
    return state;
  }
};

const searchQueryforDevice = (state = "", action) => {
  if (action.type === SEARCH_DEVICES) {
    return action.query;
  } else {
    return state;
  }
};
const filterBarVisible = (state = false, action) => {
  if (action.type === TOGGLE_FILTER_BAR) {
    return !state;
  } else return state;
};

const pageTitle = (state = "Signoxe", action) => {
  if (action.type === SET_PAGE_TITLE) {
    return action.title;
  } else return state;
};

const helpVisible = (state = false, action) => {
  if (action.type === HELP_TOGGLE) {
    return !state;
  } else return state;
};

const assetsView = (state = "TILE", action) => {
  if (action.type === SWITCH_ASSETS_VIEW) {
    return action.view;
  } else return state;
};

const assetsSort = (state = { sortBy: "ID", reversed: true }, action) => {
  if (action.type === SORT_ASSETS) {
    // If the user sorts by the same parameter twice, the direction should reverse.
    // If the user changes the sorting parameter, the direction should revert to default (false)
    // If a value for reversed is provided that should be used instead.
    let reversed = false; // default value
    if (action.reversed === null || action.reversed === undefined) {
      if (state.sortBy === action.sortBy) {
        reversed = !state.reversed;
      }
    } else {
      reversed = action.reversed;
    }
    return {
      sortBy: action.sortBy,
      reversed,
    };
  } else return state;
};

const aqiStations = (state = { cities: [], stations: {} }, action) => {
  switch (action.type) {
    case SET_AQI_CITIES:
      return { ...state, cities: action.cities };
    case SET_AQI_STATIONS:
      return {
        ...state,
        stations: { ...state.stations, [action.city]: action.stations },
      };
    default:
      return state;
  }
};

const airVedaStations = (state = { stations: [] }, action) => {
  switch (action.type) {
    case SET_AIRVEDA_STATIONS:
      return action.stations;
    default:
      return state;
  }
};

const quizStations = (state = { stations: [] }, action) => {
  switch (action.type) {
    case SET_QUIZ_STATIONS:
      return action.stations;
    default:
      return state;
  }
}

const weatherStations = (state = { stations: [] }, action) => {
  switch (action.type) {
    case SET_WEATHER_STATIONS:
      return action.stations;
    default:
      return state;
  }
};

const videoTranscoding = (state = { transcodedVideos: [] }, action) => {
  switch (action.type) {
    case TRANSCODE_VIDEO:
      return {
        ...state,
        transcodedVideos: [...state.transcodedVideos, action.id],
      };
    default:
      return state;
  }
};

const uiState = combineReducers({
  uploadTrayOpen,
  uploadTypeSwitch,
  uploadDispatchState,
  uploadStartState,
  confirmation,
  searchQuery,
  filterBarVisible,
  pageTitle,
  helpVisible,
  assetsView,
  assetsSort,
  aqiStations,
  videoTranscoding,
  airVedaStations,
  quizStations,
  searchQueryforDevice,
  playlistUpdateTags,
  bulkPlaylistsUpdate,
  playlistDetail
});

export default uiState;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/reducers/uiState.js